// @@TODO: https://github.com/vercel/next.js/discussions/53063

'use client'

import { useEffect, useRef, useState } from 'react'
import { useTheme } from 'next-themes'
import { ClockIcon, MoonIcon, SunIcon } from '@heroicons/react/24/solid'
import { getCookie, setCookie } from 'cookies-next'

export const isSystemDark = (theme: string | undefined) => {
  if (
    theme === 'system' &&
    typeof window !== 'undefined' && // NOSONAR
    window.matchMedia('(prefers-color-scheme: dark)').matches // NOSONAR
  ) {
    return true
  }
  // Not 'system'
  // On server
  // Scheme prefers 'light'
  return false
}

const LightSwitch = () => {
  const { theme, setTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  // cycle: light > dark > system
  const cycleLightSwitch = () => {
    if (theme === 'light') {
      //setCookie('DASH_THEME', 'dark')
      setTheme('dark')
    } else if (theme === 'dark') {
      //setCookie('DASH_THEME', 'system')
      setTheme('system')
    } else {
      //setCookie('DASH_THEME', 'light')
      setTheme('light')
    }
  }

  // Ref for the event handler function to maintain identity between renders
  const handlerRef = useRef<((event: KeyboardEvent) => void) | null>(null)

  useEffect(() => {
    setMounted(true)
    return () => setMounted(false)
  }, [])

  useEffect(function setKeyHandler() {
    // NOTE: Call async function without awaiting; safe to ignore the promise in this event handler context
    // @@TODO: Is this an async function?
    handlerRef.current = (event: KeyboardEvent): void => {
      console.log('toggleOptionKey() - a key pressed')
      if (event.isComposing || event.key === 'Alt') {
        console.log('toggleOptionKey() - alt key pressed')
        // @@TODO
        //cycleLightSwitch()
      }
    }
  }, [])

  useEffect(function setupListeners() {
    // Prevent adding unlimited event listeners (due to hot reload in dev mode).
    const listener = (event: KeyboardEvent) => handlerRef.current?.(event)
    window.addEventListener('keydown', listener) // NOSONAR
    return function cleanupListeners() {
      window.removeEventListener('keydown', listener) // NOSONAR
    }
  })

  if (!mounted) {
    // @@TODO: On server
    // 'light', 'dark', 'system', undefined
    //const theme = getCookie('DASH_THEME')
    //console.log('DASH_THEME=', theme)

    // Skeleton
    return (
      <div className="flex justify-center items-center">
        <button
          type="button"
          aria-label="light dark system mode switch"
          tabIndex={0}
          className="focus-custom flex w-7 h-7 rounded-full justify-center items-center border-custom"
        >
          <span className="flex justify-center items-center">
            {<span className="w-[22px] h-[22px] rounded-full bg-red-500" />}
          </span>
        </button>
      </div>
    )
  }

  if (mounted) {
    return (
      <button
        type="button"
        aria-label="light dark system mode switch"
        tabIndex={0}
        onClick={() => cycleLightSwitch()}
        className="focus-custom flex w-7 h-7 rounded-full justify-center items-center border-custom"
      >
        <span className="flex justify-center items-center">
          {theme === 'light' && (
            <div className="w-[22px] h-[22px]">
              <SunIcon />
            </div>
          )}
          {theme === 'dark' && (
            <div className="w-[22px] h-[22px]">
              <MoonIcon />
            </div>
          )}
          {/* NOTE: system mode can be either dark or light, depending on preferred color scheme.
           ** The colors of the LightSwitch in system mode should be updated accordingly.
           */}
          {theme === 'system' && (
            /* @@TODO: clock icon is ugly, because of thick border */
            <ClockIcon
              className={`w-[22px] h-[22px] rounded-full ${
                isSystemDark(theme)
                  ? 'text-background-dark bg-foreground-dark'
                  : 'text-background-light bg-foreground-light'
              }`}
            />
          )}
        </span>
      </button>
    )
  }
}

export default LightSwitch
